package xim.poc.game.configuration.v0.tactics.behaviors

import xim.poc.game.ActorState
import xim.poc.game.JobLevel
import xim.poc.game.configuration.SkillApplierHelper
import xim.poc.game.configuration.constants.SkillId
import xim.poc.game.configuration.constants.mskillTransmogrification_231
import xim.poc.game.configuration.v0.TacticsInstinct
import xim.poc.game.configuration.v0.tactics.*
import xim.poc.game.event.Event
import kotlin.math.pow

enum class MammetForm(val appearanceState: Int, val job: TacticsJobId) {
    Sword(appearanceState = 1, job = tacticsJob_MammetSword),
    Spear(appearanceState = 2, job = tacticsJob_MammetSpear),
    Staff(appearanceState = 3, job = tacticsJob_MammetStaff),
}

class TacticsMammetBehavior(var currentForm: MammetForm, actorState: ActorState): TacticsBehaviorController(actorState) {

    private var totalSkillCounter = 0

    override fun onBehaviorInitialized(): List<Event> {
        adjustInstincts()
        return emptyList()
    }

    override fun behaviorEnmityMultiplier(): Float {
        return when (currentForm) {
            MammetForm.Sword -> 0f
            MammetForm.Spear -> 1.5f
            MammetForm.Staff -> 1f
        }
    }

    override fun getSelectableSkills(): List<SkillId> {
        return if (totalSkillCounter >= 3) {
            listOf(mskillTransmogrification_231)
        } else {
            super.getSkills() - mskillTransmogrification_231
        }
    }

    override fun estimateSkillValue(query: TacticsSkillQuery): Float {
        val movementDistance = query.originalPosition.distance(query.destinationPosition)

        if (query.skill == mskillTransmogrification_231) {
            return if (movementDistance == 0) { 1f } else { 0f }
        }

        val distanceMultiplier = if (currentForm == MammetForm.Staff) { 1f/10f.pow(movementDistance) } else { 1f }
        return super.estimateSkillValue(query) * distanceMultiplier
    }

    override fun onSkillExecutedScoped(primaryTargetContext: SkillApplierHelper.TargetEvaluatorContext): List<Event> {
        if (primaryTargetContext.skill == mskillTransmogrification_231) {
            adjustForm()
            totalSkillCounter = 0
        } else {
            totalSkillCounter += 1
        }

        return emptyList()
    }

    private fun adjustForm() {
        currentForm = formCycle()
        actorState.appearanceState = currentForm.appearanceState

        val unit = actorState.getUnit()
        unit.currentJob = currentForm.job

        unit.jobLevels.clear()
        unit.jobLevels[currentForm.job] = JobLevel(level = unit.unitLevel.level, exp = 0)

        adjustInstincts()
        recomputeSkills()
    }

    private fun formCycle(): MammetForm {
        return when (currentForm) {
            MammetForm.Sword -> MammetForm.Spear
            MammetForm.Spear -> MammetForm.Staff
            MammetForm.Staff -> MammetForm.Sword
        }
    }

    private fun adjustInstincts() {
        val unit = actorState.getUnit()
        unit.instincts.clear()

        unit.instincts += when (currentForm) {
            MammetForm.Sword -> listOf(
                TacticsInstinct(TacticsInstincts.ignoresEnmity.id, 0),
            )
            MammetForm.Spear -> emptyList()
            MammetForm.Staff -> listOf(
                TacticsInstinct(TacticsInstincts.magicAttackBonus.id, 25),
                TacticsInstinct(TacticsInstincts.blackMagicRange.id, 2),
            )
        }
    }

}